import { render, staticRenderFns } from "./_attached_files_to_msg_form.vue?vue&type=template&id=7fda702d&"
import script from "./_attached_files_to_msg_form.vue?vue&type=script&lang=js&"
export * from "./_attached_files_to_msg_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports